import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FAILBACK_NO_RESOURCES_TOOLTIP, RecoveryScreenTabBarFlags } from '../../mocks/showcase-mock-core'

/**
 * The tab-bar action-button row shared by the Recovery and Backup screen previews,
 * so the production button gating lives in one place rather than being duplicated
 * per section.
 */
@Component({
  selector: 'showcase-tab-bar-actions',
  templateUrl: './showcase-tab-bar-actions.component.html',
  styleUrls: ['./showcase-tab-bar-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseTabBarActionsComponent {
  @Input({ required: true }) flags!: RecoveryScreenTabBarFlags

  // Tooltip for a disabled FAILBACK button when no failback resources exist
  // (shown only when there's no higher-priority disabledActionReason).
  readonly failbackNoResourcesTooltip = FAILBACK_NO_RESOURCES_TOOLTIP
}
